import UploadPresenter from './UploadPresenter';
export default UploadPresenter;
